import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import Icon from '@components/atoms/icon/icon';
import styles from './alert-paused-flag.module.scss';

interface AlertPausedFlagProps {
  showIcon?: boolean;
}

const AlertPausedFlag: React.FC<AlertPausedFlagProps> = ({ showIcon }) => {
  const { t } = useTranslation('common');

  return (
    <div className={clsx('vc-flag', styles.alertPausedFlag)}>
      {showIcon && (
        <Icon
          name="notification-off-default"
          ariaHidden
        />
      )}
      <span>{t('ALERTS.MANAGEMENT.PAUSED_LONG')}</span>
    </div>
  );
};

export default AlertPausedFlag;
